<template>
  <div class="main-content-container container-fluid px-4">
    <d-alert class="alert-royal-blue" :show="show_alert" theme="danger" ref="dalert" style="position:sticky;top:0;left:0;z-index:10000;" dismissible >
      <i class="fa fa-info mx-2"></i>
      <span id="warning">{{ error_msg }}</span> 
    </d-alert>
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">List</span>
        <h3 class="page-title">Non Donatur</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
             <d-button type="button" :disabled="loading" class="btn-accent" @click="add_new" data-toggle="tooltip" data-placement="top" title="Add New" ><i class="material-icons">note_add</i> Tambah Baru</d-button>
              &nbsp;
              <button type="button" class="btn-primary btn-sm" @click="xls()" style="padding:0.15rem 0.5rem !important">List Non Donatur</button>
          </div>
          <div class="card-body p-0 pb-3 text-center" style="overflow-x:scroll">
            <d-row style="margin:auto">
              <d-col md="2"  class="form-group" style="text-align:left">
                Batas bawah umur
               <d-form-input type="text" id="feMinAge" placeholder="Batas bawah umur" v-model="minage" />
              </d-col>
              <d-col md="2"  class="form-group" style="text-align:left">
                Batas atas umur
               <d-form-input type="text" id="feMaxAge" placeholder="Batas atas umur" v-model="maxage" />
              </d-col>
            </d-row>
            <d-row style="margin:auto">
            <d-col md="4"  class="form-group" style="text-align:left">
              Menampilkan
              <select v-model="ipp" >
                <option value=5 selected>5 item</option>
                <option value=10>10 item</option>
                <option value=15>15 item</option>
                <option value=20>20 item</option>
                <option value=0>Semua</option>
              </select>
              &nbsp;&nbsp;
            </d-col>
            <d-col md="4"  class="form-group">
            </d-col>
            <d-col md="4"  class="form-group">
              <d-form-input type="text" id="feInputAddress" placeholder="Cari" v-model.trim="search" />
            </d-col>
            </d-row>
            <d-row>
            <v-gallery :images="images" :index="index" @close="index = null"></v-gallery>
            </d-row>
        <b-table
            :data="isEmpty ? [] : data"
            :loading="loading"
            :mobile-cards="hasMobileCards"
            paginated
            backend-pagination
            :total="total"
            :per-page="perPage"
            :current-page="page"
            @page-change="onPageChange"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"

            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"            
            >

            <template slot-scope="props">
                <b-table-column field="id" label="Id" sortable>
                    <span class="tag is-success">
                    {{ props.row.id }}
                    </span>
                    <button type="button" class="btn-primary btn-sm" @click="open_data(props.row.id)" style="padding:0.15rem 0.5rem !important"><i class="material-icons" alt="edit">edit</i></button>
                </b-table-column>
                <b-table-column field="fullname" label="Nama Lengkap" sortable>
                    {{ props.row.fullname }}
                </b-table-column>
                <b-table-column field="email" label="Email" sortable>
                    {{ props.row.email }}
                </b-table-column>
                <b-table-column field="mobile_phone" label="HP" style="text-align:right" sortable>
                    {{ (props.row.mobile_phone=='0000000')? '':props.row.mobile_phone }}
                </b-table-column>
                <b-table-column field="dob" label="Tgl Lahir" sortable>
                    {{ (props.row.dob=='01-01-1900')? '':props.row.dob }}
                </b-table-column>
                <b-table-column field="age" label="Umur" sortable>
                    {{ (props.row.dob=='01-01-1900')? '':props.row.age }}
                </b-table-column>
                <b-table-column field="created_by" label="Dibuat oleh" sortable>
                    {{ props.row.created_by }}
                </b-table-column>
                <b-table-column field="memo" label="Memo" sortable>
                    {{ props.row.memo }}
                </b-table-column>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Tidak ada data.</p>
                    </div>
                </section>
            </template>
        </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileSaver from 'file-saver';
import env from '../env.vue';

    export default {
        data() {
            return {
                show_alert:false,
                data:[],
                list:[],
                error_msg:'',
                index:0,
                images:[],
                isEmpty: false,
                isHoverable: true,
                loading: false,
                hasMobileCards: true,
                sortField:'id',
                sortOrder:'asc',
                sortIcon:'arrow-up',
                sortIconSize:'is-small',
                sort:'name',
                defaultSortOrder:'asc',
                page:1,
                perPage:5,
                total:2,
                filename:'',
                ipp:5,
                search:'',
                minage:'',
                maxage:'',
            }
        },
        watch:{
          ipp(){
           if (this.ipp>0) this.perPage=this.ipp*1
           else this.perPage=this.total*1
           this.update_data();
          },
          minage(val){
           if (
                (this.minage!==''&&this.maxage!='')||
                (this.minage===''&&this.maxage=='')
             )
             this.update_data();
          },
          maxage(val){
           if (this.minage!==''&&this.maxage!='')
             this.update_data();
          },
          search(){
           if(parseInt(this.search)>0||this.search.length>3||!this.search.length)this.update_data()
          },
        },
        methods:{
          add_new(){
            this.$router.push({name:'person-form',params:{id:0},query:{id:0}});
          },
          open_data(id){
            this.$router.push({name:'person-form',params:{id:id},query:{id:id}});
          },
          save_state(){
            var arr={
              page:this.page,
              perPage:this.perPage,
              total:this.total,
              ipp:this.ipp,
              search:this.search,
              sortField:this.sortField,
              sortOrder:this.sortOrder,
            };
            this.$store.commit('list',arr);
          },
          load_state(){
            var arr=this.$store.state.list;
            if ( arr==null ) return;
            this.page=arr.page;
            this.perPage=arr.ipp>0 ? arr.perPage : arr.total;
            this.total=arr.total;
            this.ipp=arr.ipp;
            this.search=arr.search;
            this.sortField=arr.sortField;
            this.sortOrder=arr.sortOrder;
          },
          onPageChange(page){
           this.page=page;
           this.update_data();           
          },
          onSort(field,order){
           if ( !this.loading ){           
            this.sortField=field;
            this.sortOrder=order;
            this.update_data();
           }
          },
          pop_alert(msg){
            if (msg==undefined) return;
            this.$refs.dalert.dismissed=false;
            this.show_alert=5;
            this.error_msg=msg;
          },
          xls(m){
           var file='';
           this.loading=true;           
           var d= new Date();
           var report_date=d.getDate()+'-'+(d.getMonth()+1)+'-'+d.getFullYear();
           this.filename = 'data_non_donatur_' + report_date + '.xlsx';
           this.save_state();
           var url=env.server+'/person-list/excel',
           dsearch = this.search;
           this.axios.post( url,{
             start: 0,
             length: 0,
             sort: this.sortField,
             sort_order: this.sortOrder,
             scfilter: dsearch,
             minage: this.minage!=='' ? ''+this.minage:'',
             maxage: this.minage!=='' ? ''+this.maxage:'',
             }, {
              responseType: 'arraybuffer',
              headers: {
                Accept: 'application/octet-stream',
             }
             }).then(
             resp=>{
              this.loading = false;
              file = new Blob([resp.data], { type: 'application/octet-stream' });
              FileSaver.saveAs(file, this.filename);
             }
           );
          },
          update_data(){
           this.loading=true;           
           this.save_state();
           this.axios.post( env.server+'/person-list',{
             start: this.page,
             length: this.perPage>0 ? this.perPage: this.total,
             sort: this.sortField,
             sort_order: this.sortOrder,
             scfilter: this.search,
             minage: this.minage!=='' ? ''+this.minage:'',
             maxage: this.minage!=='' ? ''+this.maxage:'',
           }).then(
             resp=>{
               resp.data=JSON.parse(resp.data);
               this.loading=false;
               this.data=resp.data.data.items;
               this.total=resp.data.data.total_results;
               for (var i=0; i<this.data.length; i++ ){
                 this.data[i].idx=i;
                 let tmp=[];
                 tmp=this.data[i].dob.split('-');
                 this.data[i].dob=tmp[2]+'-'+tmp[1]+'-'+tmp[0];
               }
             }
           );
          },
        },
        mounted(){           
          var dt = new Date();
          this.ddate=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
          this.load_state();
          this.update_data();
        },
    }
</script>
